import React from "react";
// COMPONENTS
import SiteButton from "Components/WebsiteTheme/SiteButton";
import SiteSectionHead from "Components/WebsiteTheme/SiteSectionHead";
import { revealProps } from "Components/WebsiteTheme/Reveal";
import { CTA, SITE_SUBJECTS } from "Components/WebsiteTheme/site.data";
import useOpenSubject from "Components/WebsiteTheme/useOpenSubject";
// STYLES
import { HomeSubjectsSection } from "./LandingPage.style";

/** One Platform. Seven Subjects.: a photo tile per subject; each opens that subject on the Subjects page. */
const HomeSubjects = () => {
	const openSubject = useOpenSubject();

	return (
		<HomeSubjectsSection className="sm_section">
			<div className="sm_container">
				<SiteSectionHead {...revealProps("up")} align="center" title="One Platform. Seven Subjects." lead="Engaging games. Real learning. For every classroom." />

				<ul className="hs_row">
					{SITE_SUBJECTS.map((subject, index) => (
						<li key={subject.id} className={index === SITE_SUBJECTS.length - 1 ? "hs_cell--wide" : undefined} {...revealProps("up", index)}>
							<button type="button" className="hs_tile" style={{ "--tone": subject.tone }} onClick={() => openSubject(subject.id)} aria-label={`Explore ${subject.title}`}>
								<img src={subject.image} alt="" width="640" height="626" loading="lazy" />
								<span className="hs_label">{subject.title}</span>
							</button>
						</li>
					))}
					<li className="hs_action">
						<SiteButton to={CTA.subjects.to} variant="outline">
							{CTA.subjects.label}
						</SiteButton>
					</li>
				</ul>
			</div>
		</HomeSubjectsSection>
	);
};

export default HomeSubjects;
